import * as logger from "../logger";
import { getCurrentUser } from "../storage/storage";

export default class PerformanceProfileBatcher {
    private measures: { name: string; duration: number; startTime: number }[] = [];
    private readonly batchName: string;

    constructor(batchName: string) {
        this.batchName = batchName;
    }

    add(measure: { name: string; duration: number; startTime: number }) {
        this.measures.push({
            name: measure.name,
            duration: measure.duration,
            startTime: measure.startTime
        });
    }

    log() {
        if (this.measures.length === 0) {
            return;
        }

        const totalDuration = this.measures.reduce((sum, m) => sum + m.duration, 0);

        logger.event(
            logger.Event.PERFORMANCE,
            JSON.stringify({
                name: this.batchName,
                duration: (totalDuration / 1000).toFixed(3),
                startTime: this.measures.length > 0 ? this.measures[0].startTime : 0,
                breakdown: this.measures.map(m => ({
                    name: m.name,
                    duration: (m.duration / 1000).toFixed(3),
                    startTime: m.startTime
                }))
            }),
            getCurrentUser(),
            totalDuration
        );
        this.measures = [];
    }
}